import React from 'react';

const ProductAdd = () => {
    return (
        <div>
            
        </div>
    );
};

export default ProductAdd;